import React from "react";
import { connect } from "react-redux";
import {
  callAuthCalcPostDateV2,
  clearAuthRecurringValidation,
  callAuthSaveInternalInfo,
  callAuthSubmitInternalPayment,
} from "../../../actions/authPayment.actions";
import { AuthPaymentRecurringInternalTransferOpenEnd } from "../payment-forms/auth-payment-recurring-internal-transfer-open-end.component";
import { AuthRecurringOpenEndReview } from "../review/auth-recurring-open-end-review-fields.component";
import moment from "moment";
import { removeSpecialCharacters, usd } from "../../../utils/utils";
import { AuthPaymentRecurringOpenEndSummary } from "../summary/auth-payment-recurring-open-end-summary.component";

const RecurringInternalTransferOpenEndFlowComponent = (props) => {
  const currentForm = props.form["AuthPaymentRecurringInternalTransferOpenEnd"];
  const paymentResponse = props.authPayment.paymentResponse;
  const internalResponse = props.authPayment.internalResponse;
  const { setProcessStep, processStep, selectedLoan, backToLoans } = props;

  switch (processStep) {
    case 1:
      return (
        <AuthPaymentRecurringInternalTransferOpenEnd
          {...props.authPayment.selectedLoanAdditionalDetails}
          continue={() => setProcessStep(2)}
          selectedLoan={selectedLoan}
          authPayment={props.authPayment}
          thisForm={currentForm}
          callAuthCalcPostDateV2={props.callAuthCalcPostDateV2}
          callAuthSaveInternalInfo={props.callAuthSaveInternalInfo}
          clearAuthRecurringValidation={props.clearAuthRecurringValidation}
          backToLoans={backToLoans}
          internalAccounts={props.authPayment.internalAccounts}
          internalResponse={internalResponse}
        />
      );
      case 2:
        return (
          <AuthRecurringOpenEndReview
            openEndPaymentType={currentForm.values.OpenEndPaymentType}
            firstPaymentDate={moment(currentForm.values.PaymentDate).format("MM/DD/YYYY")}
            paymentFrequency={currentForm.values.PaymentFrequency}
            paymentAccount={internalResponse.CardNumberLastFour}
            paymentAmount={usd.format(removeSpecialCharacters(currentForm.values.Amount))}
            selectedLoan={selectedLoan}
            continue={() => setProcessStep(3)}
            paymentResponse={paymentResponse}
            callAuthSubmitPayment={props.callAuthSubmitInternalPayment}
            backToLoans={backToLoans}
            isInternalTransfer={true}
          />
        );
      case 3:
        return (
          <AuthPaymentRecurringOpenEndSummary
            openEndPaymentType={paymentResponse.RecurringPaymentType}
            firstPaymentDate={moment(paymentResponse.PaymentDate).format("MM/DD/YYYY")}
            paymentFrequency={paymentResponse.Frequency}
            paymentAccount={paymentResponse.CardNumberLastFour}
            paymentAmount={usd.format(paymentResponse.PaymentAmount)}
            confirmationEmail={paymentResponse.EmailAddress}
            selectedLoan={selectedLoan}
            backToLoans={backToLoans}
          />
        );
    default:
      return <div>Something has gone wrong.</div>;
  }
};

const mapDispatchToProps = {
  callAuthCalcPostDateV2,
  clearAuthRecurringValidation,
  callAuthSaveInternalInfo,
  callAuthSubmitInternalPayment,
};

const RecurringInternalTransferOpenEndFlow = connect(null, mapDispatchToProps)(RecurringInternalTransferOpenEndFlowComponent);

export default RecurringInternalTransferOpenEndFlow;



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/flow-components/recurring-internal-transfer-open-end-flow.component.js